// تبدیل ارقام انگلیسی به فارسی
export const toPersianDigits = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)]);
};

// تبدیل ارقام فارسی/عربی به انگلیسی — برای parse ورودی و جستجو
export const toEnglishDigits = (value: string | null | undefined): string => {
  if (!value) return '';
  return value
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660));
};

// قالب‌بندی عدد با جداکننده هزارگان و ارقام فارسی
export const formatPersianNumber = (value: number | string | null | undefined, decimalPlaces?: number): string => {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (isNaN(num)) return String(value);
  const formatted = num.toLocaleString('en-US', {
    maximumFractionDigits: decimalPlaces ?? 2,
  });
  return toPersianDigits(formatted);
};

// تبدیل ارقام فارسی/عربی به انگلیسی و حذف جداکننده‌ها — برای parse ورودی کاربر
export const parsePersianNumber = (value: string): number => {
  if (!value) return 0;
  const normalized = value
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/٫/g, '.') // ممیز فارسی → نقطه اعشار
    .replace(/[,،٬\s]/g, '');
  const num = Number(normalized);
  return isNaN(num) ? 0 : num;
};

// نام مستعار برای قالب‌بندی اعداد فارسی
export const formatFaNumber = formatPersianNumber;
